import { render } from "./OverviewSidebar.vue?vue&type=template&id=1b13c0be"
import script from "./OverviewSidebar.vue?vue&type=script&lang=js"
export * from "./OverviewSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__